module.exports = __webpack_public_path__ + "img/3.e82d98e6.png";